import React, { useEffect, useState } from 'react';
import { Button, Grid, Typography, Paper, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { fetchPolicyHolderByInsuree, fetchPolicyHolderByInsureeAutoRefresh, fetchPolicyHolderByInsureeByFilter } from '../action';
import { decodeId } from '../utils/helper';
import { styled } from "@mui/system";
const StyledPaper = styled(Paper)(({ theme }) => ({
    ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
    ...theme.paper.header,
    fontSize: 600,
    padding: ".8rem",
}));
const InsureeFilter = ({ policyHolderId, setFilter, filter }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [insureeNumber, setInsureeNumber] = useState('');
    const [name, setName] = useState('');
    const [autoRefresh, setAutoRefresh] = useState(false);
    const createPolicyHolderInsureePayload = ({
        policyHolderId,
        insureeNumber,
        first = 10,
        name,
        isDeleted = false,
        orderBy = ["insuree"]
    }) => {
        return `policyHolder_Id: "${decodeId(policyHolderId.id)}", insuree_ChfId_Istartswith: "${insureeNumber}",insuree_OtherNames_Icontains:"${name}", first: ${first}, isDeleted: ${isDeleted}, orderBy: [${orderBy.map(order => `"${order}"`).join(', ')}]`;
    };
    useEffect(() => {
        if (autoRefresh) {
            dispatch(fetchPolicyHolderByInsureeAutoRefresh(policyHolderId?.id))
        }
    }, [autoRefresh])
    const handleClear = () => {
        // Clear the state
        setInsureeNumber('');
        setName('');
        setFilter(!filter)
        setAutoRefresh(true)
    };

    const handleSearch = () => {
        const payload = createPolicyHolderInsureePayload({
            policyHolderId,
            insureeNumber,
            name,
            first: 10,
            isDeleted: false,
            orderBy: ["insuree"]
        });
        // Call the API function with the constructed payload
        setAutoRefresh(false)
        dispatch(fetchPolicyHolderByInsureeByFilter(payload));
    };
    return (
        <Grid container>
            <Grid item xs={12}>
                <StyledPaper>
                    <StyledPaperHeader>
                        {/* <Grid></Grid> */}
                        <Grid item alignItems="center">
                            <Typography variant="h6">{t("Search Criteria")}</Typography>
                        </Grid>
                    </StyledPaperHeader>
                    <Grid style={{ display: "flex", marginLeft: ".5rem", marginTop: "1rem", marginBottom: "1rem" }}>
                        <Grid item xs={3} className="common-input">
                            <Typography color="#000" fontSize="24" fontWeight="bold">
                                {t("Insuree Number")}
                            </Typography>
                            <TextField
                                name="insureeNumber"
                                value={insureeNumber}
                                onChange={(e) => setInsureeNumber(e.target.value)}
                                type="text"
                                size='small'
                            />
                        </Grid>
                        <Grid item xs={3} className="common-input">
                            <Typography color="#000" fontSize="24" fontWeight="bold">
                                {t("Name")}
                            </Typography>
                            <TextField
                                name="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                size='small'
                                type="text"
                            />
                        </Grid>
                        <Grid item xs={6} style={{ display: "flex", marginTop: "1.4rem" }}>
                            <Grid item xs={3} className="common-input">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSearch}
                                >
                                    {t("Search")}
                                </Button>
                            </Grid>
                            <Grid item xs={3} className="common-input">
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={handleClear}
                                    style={{marginLeft:"1rem"}}
                                >
                                    {t("Clear")}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </StyledPaper>
            </Grid>
        </Grid>
    );
};

export default InsureeFilter;
